import { UiMarketoFormModel } from "../../models";

export function mockUiMarketoFormModel({
    id = "marketo-form-1234",
    type = "uiMarketoForm",
    locale = "en",
    content = mockUiMarketoFormModelContent()
}: Partial<UiMarketoFormModel> = {}): UiMarketoFormModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiMarketoFormModelContent = UiMarketoFormModel["content"];

export function mockUiMarketoFormModelContent({
    title = "Marketo form title",
    munchkinId = "594-ATC-127",
    formId = 1114,
    munchkinIdStg = "353-DGC-691",
    formIdStg = 1157,
    successMessage = "Thanks! Someone will reach out to you shortly.",
    errorMessage = "An error occurred while processing this request. Please try again.",
    ...optionals
}: Partial<UiMarketoFormModelContent> = {}): UiMarketoFormModelContent {
    return {
        title,
        munchkinId,
        formId,
        munchkinIdStg,
        formIdStg,
        successMessage,
        errorMessage,
        ...optionals
    };
}
